import axios from 'axios'
import { URL } from '../../../env'

export default {
  data: () => ({
    syndicateCcEmails: [],
    syndicate_state: [
      'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
      'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansa',
      'Kentucky', 'Lousiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
      'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
      'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
      'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
      'West Virginia', 'Wisconsin', 'Wyoming',
    ],
    editDialog: false,
    passwordDialog: false,
    bankAccountDialog: false,
    rules: {
      required: value => !!value || 'Required.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      },
    },
    userInfo: {
      syndication: {
        syndicate_phone: {},
        syndicate_address: {},
      },
    },
  }),
  mounted() {
    this.getProfile()
  },
  methods: {
    async getProfile() {
      const resp = await axios.get(`${URL}/api/getPortalUserProfile/${localStorage.getItem('user_id')}`)
      this.userInfo = resp.data[0]
      this.userInfo.syndication.syndicate_phone = resp.data[0].syndication.syndicate_phone.length > 0 ? resp.data[0].syndication.syndicate_phone[0] : {}
      this.userInfo.syndication.syndicate_address = resp.data[0].syndication.syndicate_address.length > 0 ? resp.data[0].syndication.syndicate_address[0] : {}
      this.syndicateCcEmails = JSON.parse(resp.data[0].syndication.syndicate_cc_emails)
    },
    async submitContactInfo() {
      const s = this.userInfo.syndication
      await axios.post(`${URL}/api/updatePortalUserProfile`, {
        user_id: this.userInfo.id,
        name: this.userInfo.name,
        syndicate_id: s.id,
        syndicate_phone_number: s.syndicate_phone.syndicate_phone_number,
        syndicate_phone_type: s.syndicate_phone.syndicate_phone_type,
        syndicate_phone_id: s.syndicate_phone.id ? s.syndicate_phone.id : 0,
        syndicate_street: s.syndicate_address.syndicate_street,
        syndicate_city: s.syndicate_address.syndicate_city,
        syndicate_state: s.syndicate_address.syndicate_state,
        syndicate_zip: s.syndicate_address.syndicate_zip,
        syndicate_esign_email: s.syndicate_esign_email,
        syndicate_address_id: s.syndicate_address.id ? s.syndicate_address.id : 0,
        syndicate_cc_emails: this.syndicateCcEmails,
      })
      this.editDialog = false
    },
    async updateSyndicateBankInfo() {
      const s = this.userInfo.syndication
      await axios.post(`${URL}/api/updateSyndicateBankInfo`, {
        user_id: this.userInfo.id,
        syndicate_id: s.id ? s.id : 0,
        syndicate_bank_name: s.syndicate_bank_name,
        syndicate_account_number: s.syndicate_account_number,
        syndicate_routing_number: s.syndicate_routing_number,
      })
      this.bankAccountDialog = false
      this.getProfile()
    },
  },
}
